import { ContainedIcon } from '@frontend/icons';

export const ScheduleRequested = ({ as = 'span' }: { as?: React.ElementType }) => {
  return (
    <ContainedIcon
      as={as}
      css={{
        padding: 1,
        borderRadius: 'var(--fabric-radius-sm)',
      }}
      iconName='calendar-requested'
      color={'var(--fabric-color-seaweed-50)'}
    />
  );
};
